import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import "../../../css/dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from '../../common/ProtectedLayout';
import styled from "styled-components";

function DetailCoupon(props) {

    const location = useLocation();
    const navigate = useNavigate();

    const [coupon, setCoupon] = useState({}); // 변수명 명확하게 변경 (couponList -> coupon)
    const auth = useAuthContext();
    const modalCorrective = useRef();

    const startContent = () => {
        modalCorrective.current.showModal();
    }

    const startBeforePage = () => {
        if (location.state && location.state.beforePage) {
            navigate(location.state.beforePage);
        } else {
            navigate(-1);
        }
    }

    const ChangeContent = (e) => {
        setCoupon({ ...coupon, content: e.target.value });
    }

    const putCouponInfo = async () => {
        const requestData = {
            title: coupon.title, // API에 title이 필요하다면 유지, 없다면 제외 가능
            content: coupon.content,
            id: auth.loginId
        };
        try {
            const put_result = await axios.put(`/CouponRegist/${coupon.idx}`, requestData);
            if (put_result.data.success === true) {
                alert('수정이 완료되었습니다');
                modalCorrective.current.close();
            } else {
                alert('수정에 실패하였습니다');
            }
        } catch (error) {
            console.error('Error :', error.message);
        }
    };

    useEffect(() => {
        const getReservationDetail = async () => {
            try {
                const coupon_result = await axios.get(`/CouponRegistId/${location.state.idx}`);
                setCoupon(coupon_result.data[0]);
            } catch (error) {
                console.error('Error fetching reservation count:', error.message);
            }
        };
        getReservationDetail();
    }, [location.state.idx]);

    return (
        <PageContainer>
            <Card>
                <CardHeader>
                    <Title>쿠폰 상세 정보</Title>
                    <Badge status={1}>{coupon.kind}</Badge>
                </CardHeader>

                <SectionTitle>기본 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="쿠폰번호" value={coupon.number} />
                    <InfoItem label="쿠폰이름" value={coupon.name} />
                    <InfoItem label="쿠폰종류" value={coupon.kind} />
                    <InfoItem label="발급자" value={coupon.issuer} />
                </GridContainer>

                <SectionTitle>금액 및 수량</SectionTitle>
                <GridContainer>
                    <InfoItem label="쿠폰금액" value={coupon.amount} />
                    <InfoItem label="할인율" value={`${coupon.discount}%`} />
                    <InfoItem label="소비자가격" value={`${coupon.user_price}원`} isHighlight />
                    <InfoItem label="발행/남은수량" value={`${coupon.regist_count}장 / ${coupon.balance_count}장`} />
                </GridContainer>

                <SectionTitle>기간 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="발행기간" value={`${coupon.validity_start_date} ~ ${coupon.validity_end_date}`} span={2} />
                    <InfoItem label="사용기간" value={`발급 후 ${coupon.use_date}년 이내`} span={2} />
                </GridContainer>

                <SectionTitle>관리 메모</SectionTitle>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <Label>메모 내용</Label>
                    <ReadOnlyTextArea>
                        {coupon.content || '등록된 메모가 없습니다.'}
                    </ReadOnlyTextArea>
                </div>

                <ButtonGroup>
                    <OutlineButton onClick={startBeforePage}>목록으로</OutlineButton>
                    <PrimaryButton onClick={startContent}>메모 수정</PrimaryButton>
                </ButtonGroup>
            </Card>

            {/* 수정 모달 */}
            <StyledDialog ref={modalCorrective}>
                <DialogHeader>
                    <h3>메모 수정</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <div>
                        <Label>내용 (1000자 이내)</Label>
                        <StyledTextArea
                            value={coupon.content || ''}
                            onChange={ChangeContent}
                            placeholder="메모를 입력하세요."
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={putCouponInfo}>저장하기</PrimaryButton>
                </DialogActions>
            </StyledDialog>
        </PageContainer>
    )
}

// --- Helper Components ---
const InfoItem = ({ label, value, span = 1, isHighlight }) => (
    <div style={{ gridColumn: `span ${span}`, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Label>{label}</Label>
        <Value isHighlight={isHighlight}>{value || '-'}</Value>
    </div>
);

// --- Styled Components (80% Compact Version) ---

const PageContainer = styled.div`
    padding: 20px;
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 40px;
    box-sizing: border-box;
`;

const Card = styled.div`
    background: white;
    width: 100%;
    max-width: 900px; // 쿠폰 정보는 적당한 너비면 충분
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const CardHeader = styled.div`
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Title = styled.h2`
    font-size: 1.5rem;
    color: #111;
    margin: 0;
    font-weight: 800;
`;

const Badge = styled.span`
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    background-color: #e3f2fd;
    color: #1976d2;
`;

const SectionTitle = styled.h3`
    font-size: 1.1rem;
    color: #333;
    margin: 0 0 10px 0;
    border-left: 4px solid #006edc;
    padding-left: 10px;
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    row-gap: 16px;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const Label = styled.div`
    font-size: 0.8rem;
    color: #888;
    font-weight: 500;
    margin-bottom: 3px;
`;

const Value = styled.div`
    font-size: 0.95rem;
    color: ${props => props.isHighlight ? '#d32f2f' : '#222'};
    font-weight: ${props => props.isHighlight ? 'bold' : 'normal'};
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 5px;
    min-height: 22px;
    word-break: break-all;
`;

const ReadOnlyTextArea = styled.div`
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 0.95rem;
    line-height: 1.6;
    color: #333;
    white-space: pre-wrap;
    min-height: 100px;
    max-height: 300px;
    overflow-y: auto;
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    height: 300px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 0.95rem;
    resize: vertical;
    box-sizing: border-box;
    font-family: inherit;
    line-height: 1.6;
    &:focus { border-color: #006edc; outline: none; }
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
`;

const BaseButton = styled.button`
    padding: 8px 18px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 0.9rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #006edc;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white;
    border: 1px solid #ccc;
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

// --- Modal Styles ---
const StyledDialog = styled.dialog`
    border: none;
    border-radius: 16px;
    padding: 0;
    width: 90%;
    max-width: 800px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px;
    background: #fff;
    max-height: 80vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; border: none; font-size: 1.8rem; cursor: pointer; color: #999; line-height: 1;
    &:hover { color: #333; }
`;

export default DetailCoupon;